import Vue from 'vue';
import Router from 'vue-router';
// 使用路由
Vue.use(Router);
// 导出路由模块
export default new Router({
    routes: [
        /* {
            path: '/',
            redirect: '/index',          
        }, 
        {
            path: '/index',
            component: () => import('@/pages/index/index.vue'),
            name: 'index',
            redirect: '/sy',
            meta: {
                title: '框架页',
            },
            children:[
                {
                    path: '/sy',
                    component: () => import('@/pages/sy/index.vue'),
                    name: 'sy',
                    meta: {
                        title: '首页',
                    }
                },
                {
                    path: '/ygpp',
                    component: () => import('@/pages/ygpp/index.vue'),
                    name: 'ygpp',
                    meta: {
                        title: '用工匹配',
                    }
                },
                {
                    path: '/xs',
                    component: () => import('@/pages/xs/index.vue'),
                    name: 'xs',
                    meta: {
                        title: '消息',
                    }
                },
                {
                    path: '/wd',
                    component: () => import('@/pages/wd/index.vue'),
                    name: 'wd',
                    meta: {
                        title: '我的',
                    }
                },
            ]
        },   */
        {
            path: '/',
            redirect: '/home',
        }, 
        {
            path: '/home',
            component: () => import('@/pages/home/index.vue'),
            name: 'home',
            meta: {
                title: '会员系统',
            }
        },
        {
            path: '/login',
            component: () => import('@/pages/login/index.vue'),
            name: 'login',
            meta: {
                title: '登录',
            }
        },  
        {
            path: '/login/retrieve-password',
            component: () => import('@/pages/login/retrieve-password/index.vue'),
            name: 'retrieve-password',
            meta: {
                title: '忘记密码',
            }
        },
        {
            path: '/login/register',
            component: () => import('@/pages/login/register/index.vue'),
            name: 'register',
            meta: {
                title: '注册',
            }
        },
        {
            path: '/grzx',
            component: () => import('@/pages/grzx/index.vue'),
            name: 'grzx',
            meta: {
                title: '个人中心',
            }
        },
        {
            path: '/grzx/hyml',
            component: () => import('@/pages/grzx/hyml/index.vue'),
            name: 'hyml',
            meta: {
                title: '会员名录',
            }
        },
        {
            path: '/grzx/hyml/more',
            component: () => import('@/pages/grzx/hyml/more/index.vue'),
            name: 'hyml-more',
            meta: {
                title: '会员名录',
            }
        },
        {
            path: '/grzx/hyml/detil',
            component: () => import('@/pages/grzx/hyml/detil/index.vue'),
            name: 'hyml-detil',
            meta: {
                title: '会员详情',
            }
        },
        {
            path: '/grzx/wdhd',
            component: () => import('@/pages/grzx/wdhd/index.vue'),
            name: 'wdhd',
        },
        {
            path: '/grzx/wdhd/detil',
            component: () => import('@/pages/grzx/wdhd/detil/index.vue'),
            name: 'wdhd-detil',
            meta: {
                title: '活动详情',
            }
        },
        {
            path: '/grzx/wdgs',
            component: () => import('@/pages/grzx/wdgs/index.vue'),
            name: 'wdgs',
            meta: {
                title: '信息公示',
            }
        },
        {
            path: '/grzx/wdgs/detil',
            component: () => import('@/pages/grzx/wdgs/detil/index.vue'),
            name: 'wdgs-detil',
            meta: {
                title: '公示详情',
            }
        },
        {
            path: '/fhy',
            component: () => import('@/pages/fhy/index.vue'),
            name: 'fhy',
        },  
        {
            path: '/rhsq',
            component: () => import('@/pages/rhsq/index.vue'),
            name: 'rhsq',
            meta: {
                title: '入会申请',
            }
        },  
        {
            path: '/rhsq/rhsq-pc',
            component: () => import('@/pages/rhsq/rhsq-pc/index.vue'),
            name: 'rhsq-pc',
            meta: {
                title: '入会申请',
            }
        },  
        {
            path: '/grzx/jbxx',
            component: () => import('@/pages/grzx/jbxx/index.vue'),
            name: 'jbxx',
            meta: {
                title: '个人信息',
            }
        },
        {
            path: '/grzx/wdjf',
            component: () => import('@/pages/grzx/wdjf/index.vue'),
            name: 'wdjf',
            meta: {
                title: '我的积分',
            }
        },
        {
            path: '/grzx/smqd',
            component: () => import('@/pages/grzx/smqd/index.vue'),
            name: 'smqd',
            meta: {
                title: '签到',
            }
        },
        {
            path: '/grzx/smqd/qdcg',
            component: () => import('@/pages/grzx/smqd/qdcg/index.vue'),
            name: 'qdcg',
            meta: {
                title: '签到成功',
            }
        },
        {
            path: '/grzx/wdzs',
            component: () => import('@/pages/grzx/wdzs/index.vue'),
            name: 'wdzs',
            meta: {
                title: '我的证书',
            }
        },
        {
            path: '/grzx/wdzs/detil',
            component: () => import('@/pages/grzx/wdzs/detil/index.vue'),
            name: 'wdzs-detil',
            meta: {
                title: '证书详情',
            }
        },
    ]
});




// WEBPACK FOOTER //
// ./src/router/index.js